import { useState, useEffect } from "react";

export const useDebounce = (value: string, delay: number) => {
    const [debounced, setDebounced] = useState(value);

    useEffect(() => {
        const update = setTimeout(() => {
            setDebounced(value);
        }, delay);
        return () => {
            clearTimeout(update);
        };
    }, [value, delay]);

    return debounced;
};
